const trimEndSlash = (value) => value.replace(/\/+$/, '')
const normalizeApiPath = (value) => {
  const path = value
  return path.startsWith('/') ? trimEndSlash(path) : `/${trimEndSlash(path)}`
}

const normalizeApiBaseUrl = () => {
  const baseUrl = process.env.VUE_APP_BASE_URL
  const apiUrl = process.env.VUE_APP_API_URL
  if (!baseUrl || !apiUrl) {
    throw new Error('Missing VUE_APP_BASE_URL or VUE_APP_API_URL')
  }

  return `${trimEndSlash(baseUrl)}${normalizeApiPath(apiUrl)}`
}

const request = async (path, options) => {
  const response = await fetch(`${normalizeApiBaseUrl()}${path}`, options)
  const result = await response.json().catch(() => null)
  if (!response.ok) {
    throw new Error((result && result.msg) || 'Request failed')
  }
  if (result && result.code !== 0) {
    throw new Error(result.msg || 'Request failed')
  }
  return result ? result.data : null
}

export const submitExpertContact = (payload) => {
  const formData = new FormData()
  formData.append('name', payload.name)
  formData.append('company', payload.company)
  formData.append('position', payload.position)
  formData.append('mobile', payload.mobile)
  formData.append('email', payload.email)
  formData.append('industryExperience', payload.industryExperience)
  if (payload.attachmentFile) {
    formData.append('attachmentFile', payload.attachmentFile)
  }

  return request('/website/contact/expert', {
    method: 'POST',
    body: formData
  })
}

export const submitCareerContact = (payload) => {
  const formData = new FormData()
  formData.append('type', String(payload.type))
  formData.append('name', payload.name)
  formData.append('mobile', payload.mobile)
  formData.append('email', payload.email)
  formData.append('industryExperience', payload.industryExperience)
  if (payload.attachmentFile) {
    formData.append('attachmentFile', payload.attachmentFile)
  }

  return request('/website/contact/career', {
    method: 'POST',
    body: formData
  })
}

export const submitCustomerContact = (payload) => {
  return request('/website/contact/customer', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: payload.name,
      company: payload.company,
      position: payload.position,
      mobile: payload.mobile,
      email: payload.email,
      remark: payload.remark
    })
  })
}
